import React from 'react';

import AlignRightButton from './AlignRightButton';

export default function installAlignRightPlugin(config) {
  const { slate } = config.settings;

  slate.buttons.alignRight = () => (
    <AlignRightButton />
  );

  return config;
}